<template>
    <span v-if="any">
        <span v-html="start" />
        &mdash;
        <span v-html="end" />
    </span>
</template>
<script>
import moment from 'moment'

function parseFuzzyDate(fuzzyDate) {
    if (!fuzzyDate || !fuzzyDate.year || !fuzzyDate.month) {
        return null
    }

    const date = moment({
        year: fuzzyDate.year,
        month: fuzzyDate.month ? fuzzyDate.month - 1 : fuzzyDate.month,
        day: fuzzyDate.day,
    })

    if (!date.isValid()) {
        return null
    }

    return date
}

function formatDate(date) {
    let formatted = date.format('MMM YYYY')

    if (date > moment()) {
        formatted = `<strong>${formatted}</strong>`
    }

    return formatted
}

export default {
    props: {
        item: { type: Object, required: true },
    },
    computed: {
        any() {
            return this.start || this.end
        },
        end() {
            const endDate = this.endDate

            if (endDate) {
                return formatDate(endDate)
            }

            if (this.item.current) {
                return 'Present'
            }

            if (this.future) {
                return null
            }

            return 'N/A'
        },
        endDate() {
            return parseFuzzyDate(this.item.endDate)
        },
        future() {
            return this.item.future || this.startDate > moment()
        },
        start() {
            const startDate = this.startDate

            if (startDate) {
                return formatDate(startDate)
            }

            if (this.item.future) {
                return '<strong>TBD</strong>'
            }

            return 'N/A'
        },
        startDate() {
            return parseFuzzyDate(this.item.startDate)
        },
    },
}
</script>
